@if (chat) {
  <div class="audio-card">
    @if (chat.get("Owner") === appConfig.Shared.Assistant.Owner.DOCTOR) {
      <div class="icon">
        @if (doctor) {
          <img [src]='doctor.doctorDisplayImage || doctor.DoctorImageThumbnail || "https://cdn.cureskin.com/app/img/dp-dr-charu.jpg"' />
        }
      </div>
    }
    <div [ngClass]="{ 'content' : chat.get('Mode') !== appConfig.Shared.Assistant.Mode.AUDIO_MESSAGE, 'tw-flex-grow-1 tw-pr-[15px] tw-pt-0 tw-pb-0 tw-flex tw-flex-col tw-text-gray-800': chat.get('Mode') === appConfig.Shared.Assistant.Mode.AUDIO_MESSAGE }">
      @if (chat.get('Mode') !== appConfig.Shared.Assistant.Mode.AUDIO_MESSAGE) {
        <div class="fontS1">
          {{isDoctorCallExperiment ? '"Please listen to your audio message"' :
          chat.get('Message')}}
        </div>
      }
      @if (chat.get('Mode') === appConfig.Shared.Assistant.Mode.AUDIO_MESSAGE) {
        <div class="fontS1">
          Please listen to your audio message
        </div>
      }
      @if (chat.get('Mode') === appConfig.Shared.Assistant.Mode.AUDIO && chat.get('audioUrl')) {
        <audio class="mT10" controls="controls" controlslist="nodownload" (error)="audioError($event)" type="audio/mpeg" (play)="onAudioPlay($event, chat)" (ended)="onAudioPlayEnd($event, chat)">
          <source [src]="chat.get('audioUrl')" />
        </audio>
      }
      @if (chat.get('Mode') !== appConfig.Shared.Assistant.Mode.AUDIO) {
        <audio class="tw-w-full tw-h-[45px] tw-mt-[10px]" controls="controls" controlslist="nodownload" (error)="audioError($event)" type="audio/mpeg/mp3" (play)="onAudioPlay($event, chat)" (ended)="onAudioPlayEnd($event, chat)">
          <source [src]="chat.get('Message')" />
        </audio>
      }
      @if (isInternalUser) {
        <div class="fontS1 mT10">
          <div class="bold">Internal Note:</div>
          <div class="mT5">{{chat.get('internalNote')}}</div>
        </div>
      }
      @if (chat.get('Mode') !== appConfig.Shared.Assistant.Mode.AUDIO_MESSAGE) {
        <div class="timestamp">
          @if (chat.get('trackingDetails')?.audioPlayed && isInternalUser) {
            <em class="cs-icon-tick clr-green fontS2"></em>
            }@if (chat.get('trackingDetails')?.audioFinished && isInternalUser) {
            <em class="cs-icon-tick clr-green fontS2"></em>
            }<span>{{chat.get('createdAt') | date: (isInternalUser ? 'hh:mm a dd MM yy' :
            'hh:mm a') }} &nbsp; {{isInternalUser ? chat.get('OperatorName') ||
          chat.get('Owner') : ''}}</span>
        </div>
      }
    </div>
  </div>
}